import { useEffect } from "react"

import { getCallOutcomeLabel } from "./customerCalls"
import styles from "./CustomerCallsSection.module.scss"
import type { CustomerCallLog } from "./types"

export const CustomerCallsCallDetail = ({ call, onClose }: { call: CustomerCallLog; onClose: () => void }) => {
  useEffect(() => {
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose()
    }

    document.addEventListener("keydown", closeOnEscape)
    return () => document.removeEventListener("keydown", closeOnEscape)
  }, [onClose])

  return (
    <div
      className={styles.overlay}
      onMouseDown={event => {
        if (event.target === event.currentTarget) onClose()
      }}
    >
      <aside className={styles.sheet} role="dialog" aria-modal="true" aria-label="Call detail">
        <div className={styles.sheetHeader}>
          <button className={styles.close} type="button" aria-label="Close" onClick={onClose}>
            ×
          </button>
          <h3>Call detail</h3>
          <p>
            {call.customerName} · {call.timestamp}
          </p>
        </div>
        <div className={`${styles.card} ${styles.sheetCard}`}>
          <div className={styles.label}>Outcome</div>
          <span
            className={`${styles.outcome} ${call.outcome === "answered" ? styles.outcomeAnswered : styles.outcomeMissed}`}
          >
            {getCallOutcomeLabel(call.outcome)}
          </span>
          <div>
            {[
              ["Customer", call.customerName],
              ["From", call.phone],
              ["Trade line", call.tradeLine],
              ["Ring time", call.ringTime],
              ["Talk time", call.talkTime],
            ].map(([label, value]) => (
              <div className={styles.detail} key={label}>
                <span>{label}</span>
                <strong>{value}</strong>
              </div>
            ))}
          </div>
        </div>
        <div className={`${styles.card} ${styles.sheetCard}`}>
          <div className={styles.label}>Call timeline · {call.source}</div>
          <div className={styles.timeline}>
            {call.timeline.map((event, index) => (
              <div className={styles.event} key={`${event.time}-${index}`}>
                <span className={styles.small}>{event.time}</span>
                <i className={styles.dot} />
                <div>
                  <strong>{event.title}</strong>
                  <span className={styles.small}>{event.description}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </aside>
    </div>
  )
}
